import { Button, Eyebrow } from '@pelotoncycle/design-system';
import React from 'react';
import styled, { css } from 'styled-components';
import { spaces } from '@engage/styles/spaces';
import { Copy } from '../../copy/renderers';
import { useIsRemoteActivationFlowImprovementsEnabled } from '../../hooks/useIsRemoteActivationFlowImprovementsEnabled';
import { useAuth } from '../auth/OauthProvider';
import { Avatar } from '../ui/Avatar';
import { smallTitleText, linkStyle, StyledOnboardingButton } from '../ui/presets';

const UserSelectView: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { user, activateDevice, changeUsers } = useAuth();
  const isRemoteActivationFlowImprovementsEnabled =
    useIsRemoteActivationFlowImprovementsEnabled();

  return (
    <UserSelectContainer>
      <AvatarContainer>
        <Avatar
          imageUrl={user?.picture}
          username={user?.preferred_username || user?.name}
        />
      </AvatarContainer>

      <UserName data-test-id="accountUserName">
        {user?.preferred_username || user?.name}
      </UserName>

      {isRemoteActivationFlowImprovementsEnabled ? (
        <>
          <Button
            width="adaptive"
            color="light"
            variant="solid"
            data-test-id="updatedContinueButton"
            style={{ width: 280 }}
            type="submit"
            onClick={() => activateDevice()}
          >
            <Copy id="remoteActivation.continueLabel" />
          </Button>
          <SkipLink
            underline
            data-test-id="useDifferentAccountLink"
            onClick={changeUsers}
          >
            <Eyebrow size="small">
              <Copy id="remoteActivation.switchUser" />
            </Eyebrow>
          </SkipLink>
        </>
      ) : (
        <>
          <StyledOnboardingButton
            data-test-id="continueButton"
            onClick={() => activateDevice()}
          >
            <Copy id="remoteActivation.continueLabel" />
          </StyledOnboardingButton>
          <SkipLink
            underline={false}
            data-test-id="useDifferentAccountLink"
            onClick={changeUsers}
          >
            <Copy id="remoteActivation.switchUsers" />
          </SkipLink>
        </>
      )}
    </UserSelectContainer>
  );
};

const UserSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AvatarContainer = styled.div`
  margin-bottom: ${spaces.small}px;
`;

const UserName = styled.div`
  ${smallTitleText};
  padding-bottom: ${spaces.xHuge}px;
`;

const SkipLink = styled.button<{ underline?: boolean }>`
  ${linkStyle};
  margin: auto;
  margin-top: ${spaces.xxxLarge}px;
  ${props =>
    props.underline &&
    css`
      text-decoration: underline;
      text-underline-offset: 4px;
    `}
`;

export default UserSelectView;
